import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeNg = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "-1 -1 17 17",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.98657 0.135576C7.24481 -0.045192 7.58852 -0.045192 7.84676 0.135576L14.5134 4.80224C14.7139 4.94259 14.8333 5.17193 14.8333 5.41667V14.0833C14.8333 14.4975 14.4975 14.8333 14.0833 14.8333H9.75C9.33579 14.8333 9 14.4975 9 14.0833V10.4167C9 9.54222 8.29112 8.83333 7.41667 8.83333C6.54222 8.83333 5.83333 9.54222 5.83333 10.4167V14.0833C5.83333 14.4975 5.49755 14.8333 5.08333 14.8333H0.75C0.335786 14.8333 0 14.4975 0 14.0833V5.41667C0 5.17193 0.119408 4.94259 0.319903 4.80224L6.98657 0.135576ZM1.5 5.80716V13.3333H4.33333V10.4167C4.33333 8.71379 5.71379 7.33333 7.41667 7.33333C9.11954 7.33333 10.5 8.71379 10.5 10.4167V13.3333H13.3333V5.80716L7.41667 1.66549L1.5 5.80716Z"
	})
});
export default SvgHomeNg;
